import { useState } from "react";
import { changePassword } from "../services/securityService";
import {
    FaLock,
    FaKey,
    FaShieldAlt,
    FaLaptop,
} from "react-icons/fa";

import "./CustomerSecuritySettings.css";

function CustomerSecuritySettings() {

    const [form, setForm] = useState({

        currentPassword: "",

        newPassword: "",

        confirmPassword: "",

    });

    const handleChange = (e) => {

        setForm({

            ...form,

            [e.target.name]: e.target.value,

        });

    };

    const handleSubmit = async () => {

    if (

        form.newPassword !== form.confirmPassword

    ) {

        alert("Passwords do not match.");

        return;

    }

    try {

        const res = await changePassword({

            currentPassword:

                form.currentPassword,

            newPassword:

                form.newPassword,

        });

        alert(res.message);

        setForm({

            currentPassword: "",

            newPassword: "",

            confirmPassword: "",

        });

    }

    catch (error) {

        alert(

            error.response?.data?.message ||

            "Failed to update password."

        );

    }

};

    return (

        <div className="security-page">

            <div className="security-header">

                <FaShieldAlt />

                <div>

                    <h2>

                        Security Settings

                    </h2>

                    <p>

                        Protect your HomeFoods account.

                    </p>

                </div>

            </div>

            <div className="security-card">

                <h3>

                    Change Password

                </h3>

                <div className="security-input">

                    <FaLock />

                    <input
                        type="password"
                        name="currentPassword"
                        placeholder="Current Password"
                        value={form.currentPassword}
                        onChange={handleChange}
                    />

                </div>

                <div className="security-input">

                    <FaKey />

                    <input
                        type="password"
                        name="newPassword"
                        placeholder="New Password"
                        value={form.newPassword}
                        onChange={handleChange}
                    />

                </div>

                <div className="security-input">

                    <FaKey />

                    <input
                        type="password"
                        name="confirmPassword"
                        placeholder="Confirm Password"
                        value={form.confirmPassword}
                        onChange={handleChange}
                    />

                </div>

                <button
                    className="update-btn"
                    onClick={handleSubmit}
                >

                    Update Password

                </button>

            </div>

            <div className="device-card">

                <h3>

                    Logged-in Device

                </h3>

                <div className="device">

                    <FaLaptop />

                    <div>

                        <h4>

                            Windows • Chrome

                        </h4>

                        <p>

                            Current Device

                        </p>

                    </div>

                </div>

                <button className="logout-btn">

                    Logout All Devices

                </button>

            </div>

            <div className="twofactor-card">

                <h3>

                    Two Factor Authentication

                </h3>

                <p>

                    Coming Soon

                </p>

            </div>

        </div>

    );

}

export default CustomerSecuritySettings;